export default __webpack_public_path__ + "90cf7e62c7a852df5aad4457cb927b8e-marker.svg";